<template>
  <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners">
        <span slot="title">
          <icon-font v-if="menuInfo.meta.iconfont" :type="menuInfo.meta.iconfont" />
          <a-icon v-if="!menuInfo.meta.iconfont&&menuInfo.meta.icon" :type="menuInfo.meta.icon"/>
          <span>{{
            menuInfo.meta.messageKey ? $t(menuInfo.meta.messageKey) : menuInfo.meta.title
          }}</span>
        </span>
    <template v-for="item in menuInfo.children">
      <a-menu-item v-if="!item.children" :key="item.key"
                   @click="() =>$router.push({ path: item.path, query: $route.query })">
        <a-icon v-if="!item.meta.iconfont&&item.meta.icon" :type="item.meta.icon"/>
        <icon-font v-if="item.meta.iconfont" :type="item.meta.iconfont" />
        <span>{{ item.meta.messageKey ? $t(item.meta.messageKey) : item.meta.title }}</span>
      </a-menu-item>
      <sub-menu v-else :key="item.key" :menu-info="item" />
    </template>
  </a-sub-menu>
</template>
<script>
import { Menu } from 'ant-design-vue'
import Icon from 'ant-design-vue/es/icon'
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2733048_pwsnsjh4bsb.js'
})
export default {
  name: 'SubMenu',
  // must add isSubMenu: true
  isSubMenu: true,
  props: {
    ...Menu.SubMenu.props,
    menuInfo: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    IconFont
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/SubMenu.vue